<template>
  <div v-if="concreteServiceLevel" class="client-header__cart-item">
    <div class="client-header__cart-service">
      <h3 class="client-header__cart-service-name">{{concreteServiceLevel.name}}</h3>
      <div class="client-header__cart-service-type">{{concreteService && concreteService.name}}, {{concreteService && concreteService.price}}₽</div>
      <div
        class="client-header__cart-service-param"
        v-for="(option, index) in options"
        :key="index"
      >{{option ? option.name : ''}}, {{option ? (option.price - 0) : 0}}₽</div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "OneCartItem",
  props: {
    service: Object,
    idx: Number
  },
  computed: {
    ...mapState("client", ["date", "currentSalonId", "companyId"]),
    ...mapGetters("salons", ["getConcreteService"]),

    concreteServiceLevel() {
      const { serviceId, subServiceId, concreteServiceId } = this.service;
      return this.getConcreteService(
        this.currentSalonId,
        serviceId,
        subServiceId,
        concreteServiceId
      );
    },

    concreteService() {
      const {
        serviceId,
        subServiceId,
        concreteServiceId,
        concreteServiceLevelId
      } = this.service;
      return this.getConcreteService(
        this.currentSalonId,
        serviceId,
        subServiceId,
        concreteServiceId,
        concreteServiceLevelId
      );
    },

    options() {
      const { optionsIds } = this.service;
      if (this.concreteService && this.concreteService.options) {
        return this.concreteService.options.filter(({ id }) =>
          optionsIds.includes(id)
        );
      }
      return [];
    }
  }
};
</script>
